import { ClassNames } from '../utils/ClassNames';
import FormatePrice from '../utils/FormatePrice';
import { BsArrowUpRight } from 'react-icons/bs';


const Card = ({ img, title, amount, percent, icon, bgColor, date }) => {
  return (
    <div className={`${ClassNames(bgColor === "red" ? "bg-[#FF0000] text-white": "bg-white text-black")} mt-2 rounded-md px-4 py-5`}>
            <div className="flex items-center">
              <div className="rounded-full bg-[#F5F7F9] p-2 mr-2">
                <p className='text-2xl text-primaryRed'>{img}</p>
              </div>
              <p className="text-sm">{title}</p>
            </div>
            <p className="text-3xl font-bold my-3">{FormatePrice(amount)}</p>
            <div className="flex items-center">
                <div className="flex items-center">
                    { icon === "icon" ? <BsArrowUpRight className='text-green-600 text-md' />: '' }
                    {percent && (
                      <p className="text-xs pl-2">{percent} /</p>
                    )}
                  <p className={`${ClassNames(bgColor === "red" ? "text-white" : "text-[#83879B]")} text-xs`}>{date}</p>
                </div>
            </div>
    </div>
  )
}

export default Card